/**
 * TrackListItem Component
 */

import { trackImpression } from '../../../../redux/actions/impressions';
import {
  getDefaultTrackAsset,
  getDefaultTrackInstrumentalAsset,
  getResponsiveTrackThumbnail,
  getTrackPriceElement,
} from '../../../../utils/track';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { BrowsePagePath } from '../../../../components/pages/browse/Browse';
import { QueryStringContext } from '../../../../contexts/queryString';
import { hasInstrumentalFilter } from '../../../../contexts/queryString/selectors';
import { ActionSource } from '../../../../redux/actions/analytics';
import Card, { CardOwnProps } from '../../../molecules/media/Card';

interface IOwnProps {
  track: GQL.ITrackSearchResult;
  cardProps?: Partial<CardOwnProps>;
  className?: string;
  displayPriceElement?: boolean;
  actionSource: ActionSource;
}

interface IOwnContextProps {
  hasInstrumentalFilter: boolean;
}

interface IOwnDispatchProps {
  sendTrackImpression(track: GQL.ITrackSearchResult): void;
}

type TrackListItemProps = IOwnProps & IOwnDispatchProps & IOwnContextProps;

class TrackListItem extends React.Component<TrackListItemProps> {

  componentDidMount() {
    this.props.sendTrackImpression(this.props.track);
  }

  render() {
    const {
      actionSource,
      cardProps,
      className,
      displayPriceElement = true,
      track,
    } = this.props;

    const {
      artist,
      title,
      assets,
    } = track;

    const classes = new BEM(className || 'track-list__item');
    const trackId = getDefaultTrackAsset(assets!).id;

    const thumbnail = getResponsiveTrackThumbnail(track);
    const PriceElement = displayPriceElement ?
      getTrackPriceElement(track, {
        buttonProps: {
          variant: 'pill',
          // withShadow: true,
        },
      })
      : undefined;

    let trackInstrumentalId: string | undefined;
    if (this.props.hasInstrumentalFilter && location.pathname === BrowsePagePath) {
      trackInstrumentalId = getDefaultTrackInstrumentalAsset(assets!).id;
    }

    return trackId ? (
      <li {...classes()}>
        <Card
          actionSource={actionSource}
          trackId={trackInstrumentalId || trackId}
          title={title!}
          subtitle={artist!.name!}
          image={thumbnail}
          PriceElement={PriceElement}
          trackResult={track}
          {...cardProps}
        />
      </li>
    ) : null;
  }
}

const ConnectedTrackListItem = connect<{}, IOwnDispatchProps, IOwnProps & IOwnContextProps, IStoreState>(
  null,
  (dispatch) => ({
    sendTrackImpression: (track) => {
      dispatch(trackImpression({ track }));
    },
  }),
)(TrackListItem);

const TrackListItemWithContext: React.SFC<IOwnProps> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => (
      <ConnectedTrackListItem
        hasInstrumentalFilter={hasInstrumentalFilter(ctx)}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);

export default TrackListItemWithContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/search/TrackListItem/index.tsx